import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SfCheckmarkCircleFillIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 22 22",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.983 10.996c0 6.008-4.979 10.987-10.996 10.987C4.98 21.983 0 17.004 0 10.996 0 4.979 4.97 0 10.979 0c6.017 0 11.004 4.979 11.004 10.996ZM8.971 15.839c.244.313.49.448.81.448.32 0 .582-.152.776-.448l5.291-8.295c.11-.177.22-.397.22-.6 0-.43-.372-.716-.777-.716-.253 0-.498.151-.666.43l-4.878 7.755-2.43-3.038c-.228-.295-.44-.388-.7-.388a.756.756 0 0 0-.752.768c0 .211.085.422.228.607l2.878 3.477Z",
    clipRule: "evenodd"
  })
});
export default SfCheckmarkCircleFillIcon;